import React, {useState} from "react"
import FaIcon from "components/fa_icon"
import DoughnutChart from "./doughnut_chart"
import LearnableTooltip from "./learnable_tooltip"
import {TooltipPortal} from "../tooltip"
import ProgressBadge from "./progress_badge"

function LearnableProgressBox({learnable}) {
  const knowledge_change = learnable.knowledge_change_rate
  const learnable_levels = [
    learnable.learnable_items_progress.learning,
    learnable.learnable_items_progress.mastering,
    learnable.learnable_items_progress.mastery,
    learnable.learnable_items_progress.undiscovered
  ]
  const full_mastery =
    [0, 1, 3].every(index => learnable_levels[index] === 0) &&
    learnable_levels[2] > 0
  const [target, set_target] = useState(null)

  return (
    <div className="learnable-progress-box">
      <div className="progress-donuts" ref={set_target}>
        {full_mastery &&
          <FaIcon name={"fa-star-circle"} className="progress-donut" />
        }
        {!full_mastery &&
          <div className="progress-donut">
            <DoughnutChart
              data_set={learnable_levels}
              label={"learnable-mastery"}
              single_tooltip={true}
            />
          </div>
        }
      </div>
      <TooltipPortal target={target}>
        <LearnableTooltip
          data_set={learnable_levels}
          total={learnable.learnable_items_count}
        />
      </TooltipPortal>
      <div className="title">
        {learnable.name}
      </div>
      <ProgressBadge change={knowledge_change}/>
    </div>
  )
}

export default LearnableProgressBox
